// ── 설정을 반영한 계약 폼 필수 검증 ──────────────────────────────────────────
// ⚙️ 설정에서 "필수"로 표시했고 **지금 화면에 보이는** 칸만 검사한다.
//   숨긴 칸을 필수로 두면 저장이 영영 막히므로, 안 보이는 칸은 건너뛴다.
// 설정을 못 읽었으면(config=null) utils.js 의 기존 검증을 그대로 쓴다 — 무회귀.
import { FIELD_SECTIONS, isFieldVisible, isRequired } from './contractFieldMeta';
import { validateContractForm } from './utils';

// 칸 id → 폼에서 값 꺼내기. 고른 목록은 개수가 0보다 크면 채워진 것으로 본다.
const VALUE_OF = {
  company_name:      (f) => f.company_name,
  phone:             (f) => f.phone,
  mobile_phone:      (f) => f.mobile_phone,
  address:           (f) => f.address,
  memo:              (f) => f.memo,
  courier:           (f) => f.deliveryItems?.[0]?.courier,
  tracking_number:   (f) => f.deliveryItems?.[0]?.tracking_number,
  user_name:         (f) => f.user_name,
  sales_person_name: (f) => f.sales_person_name,
  registrationType:  (f) => f.registrationType,
  contract_status:   (f) => f.contract_status,
  contract_date:     (f) => f.contract_date,
  contractProducts:  (f) => (f.contractProducts?.length ? 'y' : ''),
  serviceProducts:   (f) => (f.serviceProducts?.length ? 'y' : ''),
  promoItems:        (f) => ((f.promoItems || []).some((i) => i.item_id) ? 'y' : ''),
};

const LABELS = (() => {
  const m = {};
  FIELD_SECTIONS.forEach((s) => s.fields.forEach((f) => { m[f.id] = f.name; }));
  return m;
})();

/**
 * @returns {{errors: object, labels: string[]}} errors = { [칸id]: true }
 */
export function validateWithConfig(form, config, { isNew }) {
  if (!config) {
    const errors = validateContractForm(form);
    const labels = Object.keys(errors).map((k) => LABELS[k] || k);
    return { errors, labels };
  }
  const errors = {};
  const labels = [];
  for (const sec of FIELD_SECTIONS) {
    for (const f of sec.fields) {
      if (!isRequired(config, f.id)) continue;
      if (!isFieldVisible(config, sec.id, f.id, { isNew })) continue;
      const raw = VALUE_OF[f.id] ? VALUE_OF[f.id](form) : undefined;
      if (!String(raw ?? '').trim()) {
        errors[f.id] = true;
        labels.push(f.name);
      }
    }
  }
  return { errors, labels };
}
